import { filter } from "rxjs/operators";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Component, inject, signal } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ShellRailComponent } from "./shell-rail/shell-rail.component";
import { ShellTopbarComponent } from "./shell-topbar/shell-topbar.component";

@Component({
	selector: "app-shell",
	standalone: true,
	imports: [RouterOutlet, ShellRailComponent, ShellTopbarComponent],
	templateUrl: "./app-shell.component.html",
	styleUrl: "./app-shell.component.scss",
})
export class AppShellComponent {
	private readonly router = inject(Router);

	/**
	 * The surface width the active route asked for, via `surface` in its route
	 * data. Read from the deepest matched route so a child can set it.
	 *
	 * Absent means full width, which is right for a page of tables. A page whose
	 * content is a column of fields says so instead, and the surface shrinks to
	 * fit rather than leaving the content adrift in white space.
	 */
	readonly surface = signal<string | null>(null);

	constructor() {
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				takeUntilDestroyed(),
			)
			.subscribe(() => this.surface.set(this.readSurface()));
		this.surface.set(this.readSurface());
	}

	private readSurface(): string | null {
		let node: ActivatedRouteSnapshot | null = this.router.routerState.snapshot.root;
		let surface: string | null = null;
		while (node) {
			const asked = node.data["surface"];
			if (typeof asked === "string") {
				surface = asked;
			}
			node = node.firstChild;
		}
		return surface;
	}
}
